import { render, staticRenderFns } from "./OwalTextInput.vue?vue&type=template&id=b5a9efbc&scoped=true"
import script from "./OwalTextInput.vue?vue&type=script&lang=js"
export * from "./OwalTextInput.vue?vue&type=script&lang=js"
import style0 from "./OwalTextInput.vue?vue&type=style&index=0&id=b5a9efbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a9efbc",
  null
  
)

export default component.exports